// extracted by mini-css-extract-plugin
export default {"clickableLabel":"hDTeXwu_wkCRkw6_2ig3"};